import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
} from "react";
import right from "../../assets/svg/right.svg";
import left from "../../assets/svg/left.svg";
import gatein from "../../assets/svg/gatein.svg";
import gateout from "../../assets/svg/gateout.svg";
import dockin from "../../assets/svg/dockin.svg";
import dockout from "../../assets/svg/dockout.svg";
import queue from "../../assets/svg/queue.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import downArrow from "../../assets/svg/arrow-down.svg";
import mawalog from "../../assets/svg/mawaloglogo.svg";
import Dasharrow from "../../assets/svg/dasharrow.svg";
import DashWhitearrow from "../../assets/svg/dashwhitearrow.svg";
import axios from "axios";

import time from "../../assets/svg/time.svg";
import { DList } from "../../Constent/Constent";
import {
  BarChart,
  Cell,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  LabelList,
} from "recharts";
import {
  fetchDaywiseInData,
  getAvailableDocksApi,
  getAverageDurationApi,
  getCountApi,
  getDaywiseAverageData,
  getDepartmentWiseData,
  getDepartmentWiseDockData,
  getHistoryCountApi,
  getLiveMonitorApi,
  getLocationFreeDocksApi,
  getLocationListApi,
  getTimingListApi,
  getVehicleWiseData,
  locationBasedDockOutDockInApi,
} from "./dashboard-api";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import search from "../../assets/svg/search.svg";
import arrowDown from "../../assets/svg/arrow-down-primary.svg";
import arrowUp from "../../assets/svg/arrow-up-white.svg";
import calendar from "../../assets/svg/calendar.svg";
import debounce from "lodash.debounce";
// pdf
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ExcelPDFDashboardButtons from "./excel-pdf-download.js";
import { downloadDashboardExcelPostApi } from "../masters/master-api";
import { downloadBase64File } from "../report/report-api";
import excelIcon from "../../assets/svg/excel-icon.svg";
import pdfIcon from "../../assets/svg/pdf-icon.svg";
const data = [
  { name: "Chennai", dockIn: 120, dockOut: 100, value: 187 },
  { name: "Pune", dockIn: 80, dockOut: 60, value: 175 },
  { name: "Mumbai", dockIn: 100, dockOut: 80, value: 137 },
  { name: "Delhi", dockIn: 30, dockOut: 20, value: 116 },
  { name: "Bengaluru", dockIn: 150, dockOut: 120, value: 104 },
  { name: "Kolkata", dockIn: 90, dockOut: 70 },
  { name: "Assam", dockIn: 130, dockOut: 100 },
];

const filteredData = data.filter((item) => item.value !== undefined);

const Custom2Tooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    console.log(payload);
    return (
      <div
        style={{
          background: "hsla(0, 0.00%, 14.50%, 0.94)",
          border: "1px solid #ccc",
          color: "white",
          padding: 5,
          fontSize: 12,
          boxShadow: "0px 2px 6px hsla(0, 1.20%, 32.90%, 0.81)",
        }}
      >
        <div>{`${payload[0]?.payload?.location} : ${payload[0].value}`}</div>
      </div>
    );
  }
  return null;
};

const CustomTooltip = ({ active, payload, label }) => {
  if (
    active &&
    payload &&
    payload.length >= 2 &&
    payload[0]?.value !== undefined &&
    payload[1]?.value !== undefined
  ) {
    return (
      <div
        style={{
          backgroundColor: "#333",
          color: "#fff",
          padding: "10px",
          boxShadow: "none",
          borderRadius: "5px",
          fontSize: "14px",
        }}
      >
        <p>{label}</p>
        <p>
          <span style={{ color: "#f66" }}>●</span> Gate In : {payload[0].value}
        </p>
        <p>
          <span style={{ color: "#fbb" }}>●</span> Dock In : {payload[1].value}
        </p>
      </div>
    );
  }
  return null;
};

const CustomInput = forwardRef(({ value, onClick }, ref) => (
  <div
    onClick={onClick}
    ref={ref}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 16px",
      borderRadius: "12px",
      border: "0.6px solid #E5E5E5",
      width: "fit-content",
      cursor: "pointer",
    }}
  >
    {/* <input
    onClick={onClick}
    ref={ref}
    value={`Since ${moment(value).format("DD MMM YYYY")}`}
    readOnly
    style={{ fontSize:'12px', fontWeight:'600', fontStyle:'SemiBold', color:'#D35258' }}
  /> */}
    <span
      style={{
        fontSize: "12px",
        fontWeight: "600",
        fontStyle: "SemiBold",
        color: "#D35258",
      }}
    >
      {value !== ""
        ? `Since ${moment(value).format("DD MMM YYYY")}`
        : "Select date"}
    </span>
    <img src={calendar} alt="calendar" />
  </div>
));

const Default = () => {
  const [selectedTopBar, setSelectedTopBar] = useState("transporter");
  const [selectedSideBar, setSelectedSideBar] = useState("vehicletype");
  const [searchVehicleInOut, setSearchVehicleInOut] = useState("vehicletype");
  const [vehicleTransType, setVehicleTransType] = useState("in");

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const scrollRef = useRef(null);
  const handleScroll = (dir) => {
    const scrollAmount = 200;
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  /*  const details = Array(3).fill({
        vehicleNumber: "TN 08 AV 5645",
        time: "01:45 PM",
        dockno: "L2",
        Timer: "00:38:12",
      }); */
  const [isDownloading, setIsDownloading] = useState(false);
  const [startFromDate, setStartFromDate] = useState("");
  const [refreshDuration, setRefreshDuration] = useState(60);
  const [availableDockList, setAvailableDockList] = useState([]);
  const [dockCount, setDockCount] = useState();
  const [dockHistoryCount, setDockHistoryCount] = useState();
  const [liveMonitorList, setLiveMonitorList] = useState([]);
  const [timingList, setTimingList] = useState([]);
  const [locationBasedInAndOut, setLocationBasedInAndOut] = useState([]);
  const [freeDocks, setFreeDocks] = useState();
  const [locationDIDOCount, setLocationDIDOCount] = useState(null);
  const [selectedduration, setSelectedduration] = useState("gateIn_gateOut");

  const searchInputRef = useRef();
  const [searchText, setSearchText] = useState("");
  const [expandIndex, setExpandIndex] = useState(-1);

  const percentage = 43;
  const totalSegments = 30;
  const activeSegments = Math.round(
    ((freeDocks?.dock_percentage ?? 0) / 100) * totalSegments
  );

  const segments = Array.from({ length: totalSegments }, (_, i) => {
    const rotation = (i / totalSegments) * 180 - 90;
    const isActive = i < activeSegments;

    return (
      <rect
        key={i}
        x="-2"
        y="-90"
        width="4"
        height="20"
        fill={isActive ? "#eb4d4b" : "#eee"}
        transform={`rotate(${rotation})`}
        rx="2"
      />
    );
  });

  const [selected, setSelected] = useState(null); // no default selection
  const pickerRef = useRef();

  const handleClick = () => {
    pickerRef.current.show();
  };

  const handleChange = (year, month) => {
    setSelected({ year, month });
    console.log(`${String(month).padStart(2, "0")}${year}`);
  };

  const pickerLang = {
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
  };

  const CircleLabel = ({ x, y, width, value, height, index }) => {
    console.log({ x, y, width, value, height, index });
    const radius = 14;
    const padding = 10;
    const textX = x + padding;
    const textY = y + height / 2 + 1;
    const cx = x + width - radius - 4; // padding from right
    const cy = y + height / 2;
    const city = freeDocks?.docks[index].location;

    return (
      <g>
        <foreignObject x={textX} y={textY - 20} width={width - 40} height={42}>
          <div
            fill="#172B4D"
            dominantBaseline="middle"
            style={{
              width: `${width - 40}px`,
              height: "36px",
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
              fontFamily: "Epilogue",
              fontWeight: "400",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {city}
          </div>
        </foreignObject>
        <circle cx={cx} cy={cy} r={radius} fill="#fff" />
        <text
          x={cx}
          y={cy}
          textAnchor="middle"
          fontFamily="Epilogue"
          dominantBaseline="central"
          fill="#D35258"
          fontSize="13"
          fontWeight="600"
        >
          {value}
        </text>
      </g>
    );
  };

  useEffect(() => {
    if (startFromDate !== "") {
      getHistoryCount(moment(startFromDate).format("YYYY-MM-DD"));
    }
  }, [startFromDate]);

  const [showMonthPicker, setShowMonthPicker] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const alertDatePicTotalBookingRef = useRef(null);
  useEffect(() => {
    if (selectedMonth != null) {
      locationBasedDockOutDockIn();
    }
  }, [selectedMonth]);

  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseDatePicker);
    };
  }, []);

  const handleCloseDatePicker = (event) => {
    if (
      alertDatePicTotalBookingRef.current &&
      !alertDatePicTotalBookingRef.current.contains(event.target)
    ) {
      setShowMonthPicker(false);
    }
  };
  const handleMonthPickerChange = (date) => {
    console.log("handleDateChange.......", date);
    if (date !== undefined) {
      setSelectedMonth(date);
      setShowMonthPicker(false);
    }

    console.log("fetchOptions called from handleDateChange", date);
  };

  const [showVehicleMonthPicker, setShowVehicleMonthPicker] = useState(false);
  const [selectedVehicleMonth, setSelectedVehicleMonth] = useState(new Date());
  const alertVehicleDateRef = useRef(null);
  const handleVehicleMonthPickerChange = (date) => {
    console.log("handleDateChange.......", date);
    if (date !== undefined) {
      setSelectedVehicleMonth(date);
      setShowVehicleMonthPicker(false);
    }

    console.log("fetchOptions called from handleDateChange", date);
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseVehicleDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseVehicleDatePicker);
    };
  }, []);
  const handleCloseVehicleDatePicker = (event) => {
    if (
      alertVehicleDateRef.current &&
      !alertVehicleDateRef.current.contains(event.target)
    ) {
      setShowVehicleMonthPicker(false);
    }
  };

  const [showDeptMonthPicker, setShowDeptMonthPicker] = useState(false);
  const [selectedDeptMonth, setSelectedDeptMonth] = useState(null);
  const alertDeptDateRef = useRef(null);
  const handleDeptMonthPickerChange = (date) => {
    console.log("handleDateChange.......", date);
    if (date !== undefined) {
      setSelectedDeptMonth(date);
      setShowDeptMonthPicker(false);
    }

    console.log("fetchOptions called from handleDateChange", date);
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseDeptDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseDeptDatePicker);
    };
  }, []);
  const handleCloseDeptDatePicker = (event) => {
    if (
      alertDeptDateRef.current &&
      !alertDeptDateRef.current.contains(event.target)
    ) {
      setShowDeptMonthPicker(false);
    }
  };
  const callAllAPIs = () => {
    getAvailableDocks();
    getCount();
    getHistoryCount("");
    getLocationFreeDocks();
    getTimingList();
    getMonitorList();
    if (selectedMonth != null) {
      locationBasedDockOutDockIn();
    }
    if (selectedDeptMonth != null) {
      fetchDepartmentWiseData();
    }
    if (selectedVehicleMonth != null) {
      fetchVehicleWiseData();
    }
  };
  useEffect(() => {
    setSelectedMonth(new Date());
    setSelectedDeptMonth(new Date());
    getAvailableDocks();
    getCount();
    getHistoryCount("");

    getLocationFreeDocks();
    getTimingList();
    getMonitorList();
  }, []);

  const intervalRef = useRef(null);
  useEffect(() => {
    console.log("interval init");
    // Initial API call
    callAllAPIs();

    // Setup interval
    intervalRef.current = setInterval(() => {
      console.log("interval loop");
      callAllAPIs();
    }, refreshDuration * 1000); // convert seconds to ms

    // Cleanup on unmount
    return () => clearInterval(intervalRef.current);
  }, [refreshDuration]);

  const getAvailableDocks = async () => {
    try {
      const response = await getAvailableDocksApi();
      if (response.data.success === true) {
        setAvailableDockList(response.data.docks);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getCount = async () => {
    try {
      const response = await getCountApi();
      if (response.data.success === true) {
        setDockCount(response.data.count);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getHistoryCount = async (date) => {
    try {
      const response = await getHistoryCountApi(date);
      if (response.data.success === true) {
        setDockHistoryCount(response.data.count);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getLocationFreeDocks = async () => {
    try {
      const response = await getLocationFreeDocksApi();
      if (response.data.success === true) {
        setFreeDocks(response.data.data);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getTimingList = async () => {
    try {
      const response = await getTimingListApi();
      if (response.data.success === true) {
        setTimingList(response.data.timings);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getMonitorList = async () => {
    try {
      const response = await getLiveMonitorApi();
      if (response.data.success === true) {
        setLiveMonitorList(response.data.docks);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const locationBasedDockOutDockIn = async () => {
    try {
      const response = await locationBasedDockOutDockInApi(
        formatDateCommon(selectedMonth != null ? selectedMonth : "", "MM-YYYY")
      );
      if (response.data.success === true) {
        setLocationDIDOCount(response.data.count);
        setLocationBasedInAndOut(response.data.data);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  function formatDateCommon(inputDate, formatType) {
    try {
      if (inputDate !== undefined && inputDate !== null && inputDate !== "") {
        // Parse the input date (MM/DD/YYYY format)
        /*  const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
       
         // Format the date
         return format(parsedDate, formatType); */
        return moment(inputDate).format(formatType);
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }

  const [averageMonthDate, setAverageMonthDate] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  });
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showAveragePicker, setShowAveragePicker] = useState(false);
  const [averageData, setAverageData] = useState(null);
  const [loadingAverage, setLoadingAverage] = useState(false);
  const [averageError, setAverageError] = useState(null);

  const averagePickerTriggerRef = useRef(null);
  const averagePickerCalendarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        averagePickerCalendarRef.current &&
        !averagePickerCalendarRef.current.contains(event.target) &&
        !averagePickerTriggerRef.current.contains(event.target)
      ) {
        setShowAveragePicker(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    fetchAverageData(averageMonthDate);
  }, []);

  const fetchAverageData = async (month) => {
    setLoadingAverage(true);
    setAverageError(null);
    try {
      const response = await getAverageDurationApi({ period: month });
      if (response?.data?.success) {
        setAverageData(response.data.average);
      } else {
        setAverageError("Data not found");
      }
    } catch (err) {
      setAverageError("Something went wrong");
    } finally {
      setLoadingAverage(false);
    }
  };

  const formatAverageDate = (date, format) => {
    const options = { month: "short", year: "numeric" };
    const d = new Date(date);
    return format === "MMM, YYYY"
      ? d.toLocaleDateString("en-US", options)
      : `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  };

  const handleMonthChange = (date) => {
    const formatted = formatAverageDate(date, "yyyy-MM");
    setAverageMonthDate(formatted);
    setShowAveragePicker(false);
    fetchAverageData(formatted);
  };

  //Day wise count

  const [daywiseMonthDate, setDaywiseMonthDate] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  });
  const [showDaywiseMonthPicker, setShowDaywiseMonthPicker] = useState(false);

  const daywisePickerTriggerRef = useRef(null);
  const daywisePickerCalendarRef = useRef(null);

  const [daywiseData, setDaywiseData] = useState([]);
  const [daywisePercentage, setDaywisePercentage] = useState("");
  const [daywiseIsLow, setDaywiseIsLow] = useState("");

  const [loadingDaywise, setLoadingDaywise] = useState(false);
  const [errorDaywise, setErrorDaywise] = useState(null);

  // Call this function to get API data
  const getDaywiseData = async (month) => {
    setLoadingDaywise(true);
    setErrorDaywise(null);
    try {
      const res = await fetchDaywiseInData(month); // <-- Make sure this function is imported
      if (res?.data?.success) {
        const formatted = res.data.data?.daywise.map((item) => ({
          day: `Day ${item.day}`,
          gatein: item.gatein,
          dockin: item.dockin,
        }));
        setDaywiseData(formatted);
        setDaywisePercentage(res.data.data?.percent);
        setDaywiseIsLow(res.data.data?.is_low);
      } else {
        setErrorDaywise(res?.data?.message || "No data found");
      }
    } catch (error) {
      setErrorDaywise("Error fetching data");
    }
    setLoadingDaywise(false);
  };

  const handleDaywiseMonthChange = (date) => {
    const formatted = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}`;
    setDaywiseMonthDate(formatted);
    setShowDaywiseMonthPicker(false);
    getDaywiseData(formatted);
  };

  // Auto-fetch data on load
  useEffect(() => {
    getDaywiseData(daywiseMonthDate);
  }, []);

  // Hide picker on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        daywisePickerCalendarRef.current &&
        !daywisePickerCalendarRef.current.contains(event.target) &&
        !daywisePickerTriggerRef.current.contains(event.target)
      ) {
        setShowDaywiseMonthPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  //Day wise average

  const [dayWiseAverageMonth, setDayWiseAverageMonth] = useState(new Date());
  const [showDayWiseAveragePicker, setShowDayWiseAveragePicker] =
    useState(false);
  const [selectedDayWiseAverageType, setSelectedDayWiseAverageType] =
    useState("gatein_out");
  const [dayWiseAverageChartData, setDayWiseAverageChartData] = useState([]);
  const dayWiseAveragePickerRef = useRef(null);

  const handleDayWiseAverageMonthChange = (date) => {
    setDayWiseAverageMonth(date);
    setShowDayWiseAveragePicker(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dayWiseAveragePickerRef.current &&
        !dayWiseAveragePickerRef.current.contains(event.target)
      ) {
        setShowDayWiseAveragePicker(false);
      }
    };

    if (showDayWiseAveragePicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDayWiseAveragePicker]);

  useEffect(() => {
    const fetchAverageData = async () => {
      const period = `${dayWiseAverageMonth.getFullYear()}-${String(
        dayWiseAverageMonth.getMonth() + 1
      ).padStart(2, "0")}`;
      const payload = { period, type: selectedDayWiseAverageType };

      try {
        const data = await getDaywiseAverageData(payload);
        const formatted = data.map((item) => ({
          day: `Day ${item.day}`,
          avg: parseInt(item.avg),
        }));
        setDayWiseAverageChartData(formatted);
      } catch (error) {
        console.error("Error fetching day-wise average data:", error);
        setDayWiseAverageChartData([]);
      }
    };

    fetchAverageData();
  }, [dayWiseAverageMonth, selectedDayWiseAverageType]);

  //LOcation

  const [locations, setLocations] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const list = await getLocationListApi();
      setLocations(list);
    };
    fetchData();
  }, []);

  const handleLocationChange = (e) => {
    const selectedId = e.target.value;
    setSelectedLocationId(selectedId);
    console.log("Selected Location ID:", selectedId);
  };

  const [vehicleInOutCount, setVehicleInOutCount] = useState([]);

  useEffect(() => {
    if (selectedVehicleMonth != null) {
      fetchVehicleWiseData();
    }
  }, [
    selectedSideBar,
    selectedTopBar,
    searchVehicleInOut,
    vehicleTransType,
    selectedVehicleMonth,
  ]);
  useEffect(() => {
    /*  const delayDebounce = setTimeout(() => {
       if(selectedVehicleMonth!=null){
    fetchVehicleWiseData();
    }
    }, 500); // delay API call by 500ms

    return () => clearTimeout(delayDebounce); */
  }, [searchText]);
  const handleSearch = useCallback((event) => {
    console.log("useCallbackcalled...", selectedVehicleMonth);
    const delayDebounce = setTimeout(() => {
      fetchVehicleWiseData();
    }, 500); // delay API call by 500ms

    return () => clearTimeout(delayDebounce);
  }, []);

  const fetchVehicleWiseData = async () => {
    const period =
      selectedVehicleMonth !== null
        ? `${selectedVehicleMonth.getFullYear()}-${String(
            selectedVehicleMonth.getMonth() + 1
          ).padStart(2, "0")}`
        : "";
    const payload = {
      period: period,
      type: vehicleTransType,
      search_type: searchVehicleInOut,
      search: searchInputRef?.current?.value,
      top_bar: selectedTopBar,
      side_bar: selectedSideBar,
    };

    try {
      const data = await getVehicleWiseData(payload);

      setVehicleInOutCount(data ?? []);
    } catch (error) {
      console.error("Error fetching day-wise average data:", error);
      setVehicleInOutCount([]);
    }
  };

  const [departmentWiseData, setDepartmentWiseData] = useState([]);
  useEffect(() => {
    if (selectedDeptMonth != null) {
      fetchDepartmentWiseData();
    }
  }, [selectedLocationId, selectedDeptMonth]);

  const fetchDepartmentWiseData = async () => {
    const period = `${selectedDeptMonth.getFullYear()}-${String(
      selectedDeptMonth.getMonth() + 1
    ).padStart(2, "0")}`;
    const payload = { period: period, location_id: selectedLocationId };

    try {
      const data = await getDepartmentWiseData(payload);

      setDepartmentWiseData(data ?? []);
    } catch (error) {
      console.error("Error fetching day-wise average data:", error);
      setDepartmentWiseData([]);
    }
  };

  const [departmentWiseDockData, setDepartmentWiseDockData] = useState([]);
  const fetchDepartmentWiseDockData = async (department_id) => {
    const period = `${selectedDeptMonth.getFullYear()}-${String(
      selectedDeptMonth.getMonth() + 1
    ).padStart(2, "0")}`;
    const payload = {
      period: period,
      location_id: selectedLocationId,
      department_id: department_id,
    };

    try {
      const data = await getDepartmentWiseDockData(payload);

      setDepartmentWiseDockData(data ?? []);
    } catch (error) {
      console.error("Error fetching day-wise average data:", error);
      setDepartmentWiseDockData([]);
    }
  };
  const overallDownloadExcel = async () => {
    setIsDownloading(true);
    const response = await downloadDashboardExcelPostApi(
      "dashboard/overall_report",
      {
        start_date:
          startFromDate !== ""
            ? moment(startFromDate).format("YYYY-MM-DD")
            : "",
        period:
          dayWiseAverageMonth !== ""
            ? `${dayWiseAverageMonth.getFullYear()}-${String(
                dayWiseAverageMonth.getMonth() + 1
              ).padStart(2, "0")}`
            : "",
        type: selectedDayWiseAverageType,
        //ComIn/Out
        inout_period:
          selectedVehicleMonth !== null
            ? `${selectedVehicleMonth.getFullYear()}-${String(
                selectedVehicleMonth.getMonth() + 1
              ).padStart(2, "0")}`
            : "",
        inout_type: vehicleTransType, // '\''in'\'' or '\''out'\''
        top_bar: selectedTopBar, // '\''department'\'' , '\''vehicletype'\'', '\''vendor'\'' , '\''transporter'\'','\''customer'\''
        side_bar: selectedSideBar, // '\''department'\'' , '\''vehicletype'\'', '\''vendor'\'' , '\''transporter'\'', '\''customer'\''
        //department
        // "location_id" : 0 ,
        dept_period:
          selectedDeptMonth != null
            ? `${selectedDeptMonth.getFullYear()}-${String(
                selectedDeptMonth.getMonth() + 1
              ).padStart(2, "0")}`
            : "",
      }
    );
    setIsDownloading(false);
    if (response.status === 200) {
      if (response.data.success === true) {
        const base64String = response.data.base64; // Truncated for brevity
        const fileName = response.data.file_name;
        // Convert Base64 to Blob
        downloadBase64File(base64String, fileName);
        onFileResponse(response.data);
      } else {
        onFileResponse(response.data);
      }
    }
  };
  // pdf downlaod
  const wholeData = useRef(null);
  const timing = useRef(null);
  const liveCountRef = useRef(null);
  const historyCountRef = useRef(null);
  const locationDockInOutRef = useRef(null);
  const locationFreeDockRef = useRef(null);
  const averageDurationRef = useRef(null);
  const dayWiseGateDockInRef = useRef(null);
  const dayWiseAvgDurationRef = useRef(null);
  const vehicleWiseDockOverviewRef = useRef(null);
  const deptWiseDockOverviewRef = useRef(null);
  const liveMonitorRef = useRef(null);

  const chartRef3 = useRef(null);

  const downloadPDF = async (ref, filename) => {
    const chartElement = ref.current;
    if (!chartElement) return;

    await new Promise((resolve) => setTimeout(resolve, 500));

    html2canvas(chartElement, {
      backgroundColor: "#fff",
      scale: 2,
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF(canvas.width > canvas.height ? "l" : "p", "px", [
        canvas.width /* * 1.2 */,
        canvas.height /* * 2 */,
      ]);
      pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
      pdf.save(`${filename}.pdf`);
    });
  };
  // long pdf
  const downloadLongPDF = async (ref, fileName) => {
    if (!ref.current) return;

    const originalMaxHeight = ref.current.style.maxHeight;
    const originalOverflowY = ref.current.style.overflowY;

    ref.current.style.maxHeight = "none";
    ref.current.style.overflowY = "none";

    await new Promise((resolve) => setTimeout(resolve, 20));

    html2canvas(ref.current, {
      backgroundColor: "#fff",
      scale: 2,
      useCORS: true,
      ignoreElements: (el) => {
        // Skip elements with class "no-print"
        return el.classList.contains("no-print");
      },
    }).then((canvas) => {
      ref.current.style.maxHeight = originalMaxHeight;
      ref.current.style.overflowY = originalOverflowY;

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF(canvas.width > canvas.height ? "l" : "p", "px", [
        canvas.width,
        canvas.height,
      ]);
      pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
      pdf.save(`${fileName}.pdf`);
    });
  };

  const onFileResponse = (response) => {
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
  };

  return (
    <div ref={wholeData}>
      <div className="style-justify-between">
        <div className="style-justify-start">
          <div className="dashboard-heading">Dashboard </div>
          <div className="ms-2 style-justify-start no-print">
            <button
              className="me-2"
              onClick={
                isDownloading === false
                  ? () => {
                      overallDownloadExcel();
                    }
                  : null
              }
              style={{
                background: "none",
                border: "0.6px solid #DCDFE4",
                borderRadius: "12px",
                padding: "8px 8px",
                /* height: "32px", */
                /* width: "40px", */
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                opacity: isDownloading ? 0.6 : 1,
              }}
            >
              <img
                src={excelIcon}
                alt="excel"
                style={{ width: "14px", height: "14px" }}
              />
            </button>
            <button
              onClick={() => {
                downloadPDF(wholeData, "overall");
              }}
              className="me-2"
              style={{
                background: "none",
                border: "0.6px solid #DCDFE4",
                borderRadius: "12px",
                padding: "8px 8px",
                /* height: "32px", */
                /* width: "40px", */
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                opacity: isDownloading ? 0.6 : 1,
              }}
            >
              <img
                src={pdfIcon}
                alt="pdf"
                style={{ width: "14px", height: "14px" }}
              />
            </button>
          </div>
        </div>
        <div className="style-justify-center">
          <div className="auto-refresh me-1">Auto refresh every : </div>
          <select
            value={refreshDuration}
            onChange={(e) => {
              setRefreshDuration(e.target.value);
            }}
            style={{
              height: "36px",
              border: "1px solid #ebebeb",
              padding: "0px 16px",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              fontWeight: "600",
              fontSize: "13px",
              color: "#d35258",
            }}
          >
            <option value="30">30 sec</option>
            <option value="60">1 min</option>
            <option value="120">2 mins</option>
            <option value="180">3 mins</option>
            <option value="240">4 mins</option>
            <option value="300">5 mins</option>
          </select>
        </div>
      </div>
      <div className="mt-2 d_series">
        <button
          type="button"
          className="d_sers_btn"
          onClick={() => handleScroll("left")}
        >
          <img src={left} alt="left" srcSet="" />
        </button>

        <span className="scroller" ref={scrollRef}>
          {availableDockList.map((item, index) => (
            <div
              className={`${
                item.available_status === true ? "available_box" : ""
              } ${
                item.available_status === false &&
                item.current_status === "ontime"
                  ? "on_time_box"
                  : ""
              } ${
                item.available_status === false &&
                item.current_status === "delay"
                  ? "delay_box"
                  : ""
              } ${
                item.available_status === false &&
                item.current_status === "overdelay"
                  ? "over_delay_box"
                  : ""
              }`}
              key={"avail_dock" + index}
            >
              <div>
                <div
                  className={`${
                    item.available_status === true ? "available_text_1" : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "ontime"
                      ? "on_time_text_1"
                      : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "delay"
                      ? "delay_text_1"
                      : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "overdelay"
                      ? "over_delay_text_1"
                      : ""
                  }`}
                >
                  {item.display_name}
                </div>

                <div
                  className={`${
                    item.available_status === true ? "available_text_2" : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "ontime"
                      ? "on_time_text_2"
                      : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "delay"
                      ? "delay_text_2"
                      : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "overdelay"
                      ? "over_delay_text_2"
                      : ""
                  }`}
                >
                  {item.available_status ? "Available" : ""}
                  {item.available_status === false && (
                    <div style={{ width: "50px" }}>
                      {item.duration != null && (
                        <Timer
                          key={"overdelay_timer" + index}
                          initialSeconds={parseDuration(item.duration)}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </span>

        <button
          type="button"
          className="d_sers_btn"
          onClick={() => handleScroll("right")}
        >
          <img src={right} alt="right" srcSet="" />
        </button>
      </div>

      <Row className="row d-flex">
        <Col ref={liveCountRef} sm={12} md={6} className="mt-3">
          <div className="container_box col">
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ height: "36px" }}
            >
              <div className="style-justify-start">
                <div className="font_16_700_172B4D">Live count</div>
                <ExcelPDFDashboardButtons
                  pdfRef={liveCountRef}
                  downloadPdfRef={downloadLongPDF}
                  responseMsg={onFileResponse}
                  activeTab={"live_count"}
                  isExcel={true}
                  isPdf={true}
                />
              </div>
            </div>
            <Row className="box_contain row d-flex">
              <Col sm={12} md={3} className="mt-2 px-1">
                <div className="boxses col">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="box_icon">
                      <img src={gatein} alt="" />
                    </div>
                  </div>
                  <div className="box_text">
                    <p>Gate In</p>
                    <div className="gap-3">
                      <span
                        style={{
                          color: "#172B4D",
                          fontSize: "30px",
                          fontWeight: "700",
                        }}
                      >
                        {dockCount?.gate_in ?? "0"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={3} className="mt-2 px-1">
                <div className="boxses col">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="box_icon">
                      <img src={queue} alt="" />
                    </div>
                  </div>
                  <div className="box_text">
                    <p>In Queue</p>
                    <div className="gap-3">
                      <span
                        style={{
                          color: "#172B4D",
                          fontSize: "30px",
                          fontWeight: "700",
                        }}
                      >
                        {dockCount?.in_queue ?? "0"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={3} className="mt-2 px-1">
                <div className="boxses col">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="box_icon">
                      <img src={dockin} alt="" />
                    </div>
                  </div>
                  <div className="box_text">
                    <p>Dock In</p>
                    <div className="gap-3">
                      <span
                        style={{
                          color: "#172B4D",
                          fontSize: "30px",
                          fontWeight: "700",
                        }}
                      >
                        {dockCount?.dock_in ?? "0"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col sm={12} md={3} className="mt-2 px-1">
                <div className="boxses col">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="box_icon">
                      <img src={queue} alt="" />
                    </div>
                  </div>
                  <div className="box_text">
                    <p>Out Queue</p>
                    <div className="gap-3">
                      <span
                        style={{
                          color: "#172B4D",
                          fontSize: "30px",
                          fontWeight: "700",
                        }}
                      >
                        {dockCount?.out_queue ?? "0"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col ref={historyCountRef} sm={12} md={6} className="mt-3">
          <div className="container_box col">
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ height: "36px" }}
            >
              <div className="style-justify-start">
                <div className="font_16_700_172B4D">History</div>
                <ExcelPDFDashboardButtons
                  pdfRef={historyCountRef}
                  downloadPdfRef={downloadLongPDF}
                  responseMsg={onFileResponse}
                  activeTab={"history"}
                  isExcel={true}
                  isPdf={true}
                />
              </div>
              <div className="no-print">
                {/* <button
                    className="mx-2 border-0 px-5 py-2 rounded-3"
                    onClick={() => downloadPDF(wholeData, "Dock_data")}
                  >
                    Download
                  </button> */}
                <DatePicker
                  selected={startFromDate}
                  onChange={(date) => setStartFromDate(date)}
                  customInput={<CustomInput />}
                />
                {/*   <DatePicker
      selected={startFromDate}
      onChange={(date) => setStartFromDate(date)}
      customInput={
        <input
          value={(date) => {
    return `Since ${moment(date).format("DD MMM YYYY")}`;
  }}
          onClick={(e) => e.target.select()}
          readOnly
        />
      }
    /> */}
              </div>
            </div>
            <Row>
              <Col className=" text-center mt-2 px-1">
                <div className="boxses col">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="box_icon">
                      <img src={gatein} alt="" />
                    </div>
                  </div>
                  <div className="box_text">
                    <p>Gate In</p>
                    <div className="gap-3">
                      <span
                        style={{
                          color: "#172B4D",
                          fontSize: "30px",
                          fontWeight: "700",
                        }}
                      >
                        {dockHistoryCount?.gate_in ?? "0"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className=" text-center mt-2 px-1">
                <div className="boxses col">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="box_icon">
                      <img src={dockin} alt="" />
                    </div>
                  </div>
                  <div className="box_text">
                    <p>Dock In</p>
                    <div className="gap-3">
                      <span
                        style={{
                          color: "#172B4D",
                          fontSize: "30px",
                          fontWeight: "700",
                        }}
                      >
                        {dockHistoryCount?.dock_in ?? "0"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className=" text-center mt-2 px-1">
                <div className="boxses col">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="box_icon">
                      <img src={dockout} alt="" />
                    </div>
                  </div>
                  <div className="box_text">
                    <p>Dock Out</p>
                    <div className="gap-3">
                      <span
                        style={{
                          color: "#172B4D",
                          fontSize: "30px",
                          fontWeight: "700",
                        }}
                      >
                        {dockHistoryCount?.dock_out ?? "0"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className=" text-center mt-2 px-1">
                <div className="boxses col">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="box_icon">
                      <img src={gateout} alt="" />
                    </div>
                  </div>
                  <div className="box_text">
                    <p>Gate Out</p>
                    <div className="gap-3">
                      <span
                        style={{
                          color: "#172B4D",
                          fontSize: "30px",
                          fontWeight: "700",
                        }}
                      >
                        {dockHistoryCount?.gate_out ?? "0"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className=" text-center mt-2 px-1">
                <div className="boxses col">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="box_icon">
                      <img src={queue} alt="" />
                    </div>
                  </div>
                  <div className="box_text">
                    <p style={{ fontSize: "12px" }}>Not Handled</p>
                    <div className="gap-2">
                      <span
                        style={{
                          color: "#172B4D",
                          fontSize: "30px",
                          fontWeight: "700",
                        }}
                      >
                        {dockHistoryCount?.not_handled ?? "0"}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* chart contain */}
      <Row className="row d-flex">
        <Col ref={locationDockInOutRef} sm={12} md={6} className="mt-3">
          <div className="chart_left col">
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ height: "36px" }}
            >
              <div className="style-justify-start">
                <h3>Location based dock in & dock out</h3>
                <ExcelPDFDashboardButtons
                  locationSelectedMonth={formatDateCommon(
                    selectedMonth != null ? selectedMonth : "",
                    "MM-YYYY"
                  )}
                  pdfRef={locationDockInOutRef}
                  downloadPdfRef={downloadLongPDF}
                  responseMsg={onFileResponse}
                  activeTab={"location_wise"}
                  isExcel={true}
                  isPdf={true}
                />
              </div>
              <div
                onClick={() => setShowMonthPicker(true)}
                style={{
                  position: "relative",
                  width: "146px",
                  height: "36px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#842234",
                  }}
                >
                  {formatDateCommon(
                    selectedMonth != null ? selectedMonth : undefined,
                    "MMM, YYYY"
                  )}{" "}
                  &nbsp; <img src={downArrow} />
                </div>
                {showMonthPicker && (
                  <div
                    ref={alertDatePicTotalBookingRef}
                    style={{
                      position: "absolute",
                      top: "40px",
                      right: "0",
                      zIndex: 100,
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Calendar
                      onChange={handleMonthPickerChange}
                      value={selectedMonth}
                      view="year"
                      onClickMonth={(date) => handleMonthPickerChange(date)}
                    />
                  </div>
                )}
              </div>
            </div>

            <div
              className="d-flex gap-3"
              style={{ width: "240px", height: "32px" }}
            >
              <span
                style={{
                  color: locationDIDOCount?.is_low ? "#3D9D85" : "#fbb",
                  fontSize: "30px",
                  fontWeight: "700",
                }}
              >
                {locationDIDOCount?.percent ?? "0"}%
              </span>
              <label
                htmlFor=""
                style={{
                  color: "#66737E",
                  fontFamily: "Epilogue",
                  fontWeight: "400",
                  fontSize: "13px",
                }}
              >
                {locationDIDOCount?.is_low ? "increased" : "decreased"} from
                last month
              </label>
            </div>

            <div style={{ width: "100%", overflowX: "auto" }}>
              <BarChart
                data={locationBasedInAndOut ?? []}
                barSize={12}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                width={700}
                height={220}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis
                  dataKey="location"
                  tickFormatter={(value) =>
                    value.length > 10 ? value.substring(0, 10) + "…" : value
                  }
                />
                <Tooltip
                  content={<CustomTooltip />}
                  cursor={{ fill: "transparent" }}
                />
                <Bar
                  dataKey="in_count"
                  fill="#f66"
                  radius={[10, 10, 0, 0]}
                  activeBar={false}
                />
                <Bar
                  dataKey="out_count"
                  fill="#fbb"
                  radius={[10, 10, 0, 0]}
                  activeBar={false}
                />
              </BarChart>
            </div>
          </div>
        </Col>

        <Col ref={locationFreeDockRef} sm={12} md={6} className="mt-3">
          <div className="chart_right col">
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ height: "36px" }}
            >
              <div className="style-justify-start">
                <h3>Location based free docks</h3>
                <ExcelPDFDashboardButtons
                  startDate={
                    startFromDate !== ""
                      ? moment(startFromDate).format("YYYY-MM-DD")
                      : ""
                  }
                  pdfRef={locationFreeDockRef}
                  downloadPdfRef={downloadLongPDF}
                  responseMsg={onFileResponse}
                  activeTab={"free_dock"}
                  isExcel={true}
                  isPdf={true}
                />
              </div>
            </div>

            <div className="d-flex row">
              <div className="col-5">
                <div
                  className="flex items-center justify-center"
                  style={{ width: "100%", height: "148px" }}
                >
                  <svg width="100%" height="100%" viewBox="0 0 200 120">
                    <g transform="translate(100,100)">{segments}</g>
                    <text
                      x="100"
                      y="80"
                      textAnchor="middle"
                      fontSize="28"
                      fontWeight="500"
                      fill="#172B4D"
                    >
                      {freeDocks?.dock_percentage ?? "0"}%
                    </text>
                    <text
                      x="100"
                      y="100"
                      textAnchor="middle"
                      fontSize="12"
                      fill="#626F86"
                      fontFamily="Epilogue"
                      fontWeight={400}
                    >
                      of docks are free now
                    </text>
                  </svg>
                </div>

                <div
                  className="d-flex flex-column"
                  style={{
                    backgroundColor: "#F9F9F9",
                    padding: "15px",
                    borderRadius: "10px",
                  }}
                >
                  <div className="d-flex gap-1">
                    <div
                      style={{
                        height: "12px",
                        width: "12px",
                        borderRadius: "50px",
                        backgroundColor: "#D35258",
                        marginTop: "3px",
                      }}
                    ></div>
                    <div className="live_text">Free docks</div>
                  </div>
                  <div
                    style={{
                      color: "#172B4D",
                      fontSize: "30px",
                      fontWeight: "700",
                    }}
                  >
                    {freeDocks?.count ?? "0"}
                  </div>
                </div>
              </div>

              <div
                className="col"
                style={{
                  height: 270,
                  margin: 0,
                  padding: 0,
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    layout="vertical"
                    data={freeDocks?.docks}
                    margin={{ top: 20, right: 0, left: 0, bottom: 5 }}
                  >
                    <XAxis type="number" hide />
                    <YAxis
                      type="category"
                      dataKey="city"
                      axisLine={{ stroke: "pink", strokeWidth: 3 }}
                      tick={false}
                      width={0}
                    />
                    <Tooltip
                      content={<Custom2Tooltip />}
                      cursor={{ fill: "transparent" }}
                    />
                    <Bar
                      dataKey="count"
                      fill="#ffe6e6"
                      radius={[0, 15, 15, 0]}
                      barSize={36}
                    >
                      <LabelList dataKey="count" content={<CircleLabel />} />
                      {freeDocks?.docks?.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill="#ffe6e6" />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row
        style={{ marginTop: "16px", marginBottom: "16px" }}
        className="d-flex"
      >
        {/* Average Duration */}
        <Col ref={averageDurationRef} sm={12} md={6} lg={8}>
          <div
            style={{
              borderRadius: "16px",
              padding: "16px",
              backgroundColor: "#ffffff",
              height: "fit-content",
              overflowY: "auto",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ height: "36px", position: "relative" }}
            >
              <div className="style-justify-start">
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "16px",
                    color: "#172b4d",
                    marginBottom: "0",
                  }}
                >
                  Average duration
                </h3>
                <ExcelPDFDashboardButtons
                  averageMonthDate={averageMonthDate}
                  pdfRef={averageDurationRef}
                  downloadPdfRef={downloadLongPDF}
                  responseMsg={onFileResponse}
                  activeTab={"avg_duration"}
                  isExcel={true}
                  isPdf={true}
                />
              </div>
              <div
                ref={averagePickerTriggerRef}
                onClick={() => setShowAveragePicker(true)}
                style={{
                  position: "relative",
                  width: "146px",
                  height: "36px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#842234",
                  }}
                >
                  {averageMonthDate
                    ? formatAverageDate(averageMonthDate, "MMM, YYYY")
                    : "Select Month"}{" "}
                  &nbsp;
                  <img src={downArrow} />
                </div>
              </div>
            </div>

            {showAveragePicker && (
              <div
                ref={averagePickerCalendarRef}
                style={{
                  position: "absolute",
                  top: "76px",
                  right: "16px",
                  zIndex: 100,
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                }}
              >
                <Calendar
                  onChange={handleMonthChange}
                  value={
                    averageMonthDate
                      ? new Date(averageMonthDate + "-01")
                      : new Date()
                  }
                  view="year"
                  onClickMonth={handleMonthChange}
                />
              </div>
            )}

            {loadingAverage ? (
              <div className="mt-3">Loading...</div>
            ) : averageData ? (
              <Row className="mt-3">
                <Col sm={12} md={12} lg={4} xl={3} className="mb-3">
                  <div
                    style={{
                      backgroundColor: "#f8f8f8",
                      borderRadius: "16px",
                      padding: "16px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "16px",
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#d35258",
                        }}
                      >
                        Gate in
                      </div>
                      <img src={Dasharrow} style={{ height: "10px" }} />
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#d35258",
                        }}
                      >
                        Gate out
                      </div>
                    </div>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "24px",
                        color: "#172b4d",
                      }}
                    >
                      {averageData.gatein_out}{" "}
                      <span style={{ fontWeight: "500", fontSize: "16px" }}>
                        mins
                      </span>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={12} lg={4} xl={3} className="mb-3">
                  <div
                    style={{
                      backgroundColor: "#f8f8f8",
                      borderRadius: "16px",
                      padding: "16px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "16px",
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#d35258",
                        }}
                      >
                        Dock in
                      </div>
                      <img src={Dasharrow} style={{ height: "10px" }} />
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#d35258",
                        }}
                      >
                        Dock out
                      </div>
                    </div>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "24px",
                        color: "#172b4d",
                      }}
                    >
                      {averageData.dockin_out}{" "}
                      <span style={{ fontWeight: "500", fontSize: "16px" }}>
                        mins
                      </span>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={12} lg={4} xl={3} className="mb-3">
                  <div
                    style={{
                      backgroundColor: "#f8f8f8",
                      borderRadius: "16px",
                      padding: "16px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "16px",
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#d35258",
                        }}
                      >
                        Gate in
                      </div>
                      <img src={Dasharrow} style={{ height: "10px" }} />
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#d35258",
                        }}
                      >
                        Dock in
                      </div>
                    </div>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "24px",
                        color: "#172b4d",
                      }}
                    >
                      {averageData.gatein_dockin}{" "}
                      <span style={{ fontWeight: "500", fontSize: "16px" }}>
                        mins
                      </span>
                    </div>
                  </div>
                </Col>
                <Col sm={12} md={12} lg={4} xl={3} className="mb-3">
                  <div
                    style={{
                      backgroundColor: "#f8f8f8",
                      borderRadius: "16px",
                      padding: "16px",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "16px",
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#d35258",
                        }}
                      >
                        Dock out
                      </div>
                      <img src={Dasharrow} style={{ height: "10px" }} />
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "13px",
                          color: "#d35258",
                        }}
                      >
                        Gate out
                      </div>
                    </div>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "24px",
                        color: "#172b4d",
                      }}
                    >
                      {averageData.dockout_gateout}{" "}
                      <span style={{ fontWeight: "500", fontSize: "16px" }}>
                        mins
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
            ) : averageError ? (
              <div className="mt-3 text-danger">{averageError}</div>
            ) : null}
          </div>
        </Col>

        {/* Timings */}
        <Col ref={timing} sm={12} md={6} lg={4}>
          <div
            style={{
              borderRadius: "16px",
              padding: "16px",
              backgroundColor: "#ffffff",
              maxHeight: "200px",
              overflowY: "auto",
            }}
          >
            <div className="style-justify-start">
              <div
                style={{
                  fontWeight: "700",
                  fontSize: "16px",
                  color: "#172b4d",
                  marginBottom: "16px",
                }}
              >
                Timings :
              </div>
              <ExcelPDFDashboardButtons
                startDate={
                  startFromDate !== ""
                    ? moment(startFromDate).format("YYYY-MM-DD")
                    : ""
                }
                pdfRef={timing}
                downloadPdfRef={downloadLongPDF}
                responseMsg={onFileResponse}
                activeTab={"vehicle_timing"}
                isExcel={true}
                isPdf={true}
              />
            </div>

            <Row>
              {timingList.map((timing, index) => (
                <Col sm={12} md={12} lg={6} xl={6} className="mb-3" key={index}>
                  <div
                    style={{
                      borderRadius: "16px",
                      border: "0.6px solid #e5e5e5",
                      padding: "12px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#172b4d",
                        }}
                      >
                        {timing.name ?? "N/A"}
                      </div>
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "16px",
                          color: "#d35258",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {timing.loadintime ?? "--:--"}
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>

      <Row
        className="row d-flex"
        style={{ alignItems: "stretch", marginBottom: "16px" }}
      >
        {/* Left Column */}
        <Col ref={dayWiseGateDockInRef} sm={12} md={6} className="mt-3">
          <div className="chart_left col" style={{ height: "100%" }}>
            {/* Header with Month Picker */}
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ height: "36px" }}
            >
              <div className="style-justify-start">
                <h3>Day wise Gate In & Dock In</h3>
                <ExcelPDFDashboardButtons
                  dayWiseMonthDate={daywiseMonthDate}
                  pdfRef={dayWiseGateDockInRef}
                  downloadPdfRef={downloadLongPDF}
                  responseMsg={onFileResponse}
                  activeTab={"day_wise"}
                  isExcel={true}
                  isPdf={true}
                />
              </div>
              <div
                onClick={() => setShowDaywiseMonthPicker(true)}
                ref={daywisePickerTriggerRef}
                style={{
                  position: "relative",
                  width: "146px",
                  height: "36px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#842234",
                  }}
                >
                  {daywiseMonthDate
                    ? formatDateCommon(daywiseMonthDate, "MMM, YYYY")
                    : "Select Month"}{" "}
                  &nbsp;
                  <img src={downArrow} />
                </div>
                {showDaywiseMonthPicker && (
                  <div
                    ref={daywisePickerCalendarRef}
                    style={{
                      position: "absolute",
                      top: "40px",
                      right: "0",
                      zIndex: 100,
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Calendar
                      onChange={(date) => handleDaywiseMonthChange(date)}
                      value={
                        daywiseMonthDate
                          ? new Date(daywiseMonthDate + "-01")
                          : new Date()
                      }
                      view="year"
                      onClickMonth={(date) => handleDaywiseMonthChange(date)}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Comparison Summary */}
            <div
              className="d-flex gap-3"
              style={{ width: "240px", height: "32px" }}
            >
              <span
                style={{
                  color: daywiseIsLow ? "#3D9D85" : "#fbb",
                  fontSize: "30px",
                  fontWeight: "700",
                }}
              >
                {daywisePercentage ?? "0"}%
              </span>
              <label
                style={{
                  color: "#66737E",
                  fontFamily: "Epilogue",
                  fontWeight: "400",
                  fontSize: "13px",
                }}
              >
                {daywiseIsLow ? "increased" : "decreased"} from last month
              </label>
            </div>

            {/* Chart */}
            <div style={{ width: "100%", overflowX: "auto" }}>
              {loadingDaywise ? (
                <div>Loading...</div>
              ) : errorDaywise ? (
                <div>{errorDaywise}</div>
              ) : (
                <BarChart
                  data={daywiseData}
                  barSize={12}
                  width={700}
                  height={220}
                  margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="day" />
                  <Tooltip
                    content={<CustomTooltip />}
                    cursor={{ fill: "transparent" }}
                  />
                  <Bar dataKey="gatein" fill="#f66" radius={[10, 10, 0, 0]} />
                  <Bar dataKey="dockin" fill="#fbb" radius={[10, 10, 0, 0]} />
                </BarChart>
              )}
            </div>
          </div>
        </Col>

        {/* Right Column */}
        <Col ref={dayWiseAvgDurationRef} sm={12} md={6} className="mt-3">
          <div className="chart_left col" style={{ height: "100%" }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ height: "36px" }}
            >
              <div className="style-justify-start">
                <h3>
                  Day wise average duration{" "}
                  <span
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#626F86",
                    }}
                  >
                    (In mins)
                  </span>
                </h3>
                <ExcelPDFDashboardButtons
                  dayWiseAverageMonth={
                    dayWiseAverageMonth !== ""
                      ? `${dayWiseAverageMonth.getFullYear()}-${String(
                          dayWiseAverageMonth.getMonth() + 1
                        ).padStart(2, "0")}`
                      : ""
                  }
                  statusType={selectedDayWiseAverageType}
                  pdfRef={dayWiseAvgDurationRef}
                  downloadPdfRef={downloadLongPDF}
                  responseMsg={onFileResponse}
                  activeTab={"status_avg_duration"}
                  isExcel={true}
                  isPdf={true}
                />
              </div>
              <div
                onClick={() => setShowDayWiseAveragePicker(true)}
                style={{
                  position: "relative",
                  width: "146px",
                  height: "36px",
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    color: "#842234",
                  }}
                >
                  {formatDateCommon(dayWiseAverageMonth, "MMM, YYYY")} &nbsp;{" "}
                  <img src={downArrow} alt="arrow" />
                </div>
                {showDayWiseAveragePicker && (
                  <div
                    ref={dayWiseAveragePickerRef}
                    style={{
                      position: "absolute",
                      top: "40px",
                      right: "0",
                      zIndex: 100,
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                    }}
                  >
                    <Calendar
                      onChange={handleDayWiseAverageMonthChange}
                      value={dayWiseAverageMonth}
                      view="year"
                      onClickMonth={(date) =>
                        handleDayWiseAverageMonthChange(date)
                      }
                    />
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                overflowX: "auto",
                gap: "1rem",
                paddingBottom: "8px",
              }}
            >
              <div
                onClick={() => setSelectedDayWiseAverageType("gatein_out")}
                style={{
                  flex: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  height: "32px",
                  borderRadius: "100px",
                  padding: "8px",
                  backgroundColor:
                    selectedDayWiseAverageType === "gatein_out"
                      ? "#d35258"
                      : "#f5f5f5",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "13px",
                    color:
                      selectedDayWiseAverageType === "gatein_out"
                        ? "#ffffff"
                        : "#172b4d",
                  }}
                >
                  Gate In
                </div>
                <div>
                  <img
                    src={
                      selectedDayWiseAverageType === "gatein_out"
                        ? DashWhitearrow
                        : Dasharrow
                    }
                    alt="arrow"
                  />
                </div>
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "13px",
                    color:
                      selectedDayWiseAverageType === "gatein_out"
                        ? "#ffffff"
                        : "#172b4d",
                  }}
                >
                  Gate Out
                </div>
              </div>

              <div
                onClick={() => setSelectedDayWiseAverageType("gatein_dockin")}
                style={{
                  flex: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  height: "32px",
                  borderRadius: "100px",
                  padding: "8px",
                  backgroundColor:
                    selectedDayWiseAverageType === "gatein_dockin"
                      ? "#d35258"
                      : "#f5f5f5",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "13px",
                    color:
                      selectedDayWiseAverageType === "gatein_dockin"
                        ? "#ffffff"
                        : "#172b4d",
                  }}
                >
                  Gate In
                </div>
                <div>
                  <img
                    src={
                      selectedDayWiseAverageType === "gatein_dockin"
                        ? DashWhitearrow
                        : Dasharrow
                    }
                    alt="arrow"
                  />
                </div>
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "13px",
                    color:
                      selectedDayWiseAverageType === "gatein_dockin"
                        ? "#ffffff"
                        : "#172b4d",
                  }}
                >
                  Dock In
                </div>
              </div>

              <div
                onClick={() => setSelectedDayWiseAverageType("dockin_out")}
                style={{
                  flex: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  height: "32px",
                  borderRadius: "100px",
                  padding: "8px",
                  backgroundColor:
                    selectedDayWiseAverageType === "dockin_out"
                      ? "#d35258"
                      : "#f5f5f5",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "13px",
                    color:
                      selectedDayWiseAverageType === "dockin_out"
                        ? "#ffffff"
                        : "#172b4d",
                  }}
                >
                  Dock In
                </div>
                <div>
                  <img
                    src={
                      selectedDayWiseAverageType === "dockin_out"
                        ? DashWhitearrow
                        : Dasharrow
                    }
                    alt="arrow"
                  />
                </div>
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "13px",
                    color:
                      selectedDayWiseAverageType === "dockin_out"
                        ? "#ffffff"
                        : "#172b4d",
                  }}
                >
                  Out
                </div>
              </div>

              <div
                onClick={() => setSelectedDayWiseAverageType("dockout_gateout")}
                style={{
                  flex: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  height: "32px",
                  borderRadius: "100px",
                  padding: "8px",
                  backgroundColor:
                    selectedDayWiseAverageType === "dockout_gateout"
                      ? "#d35258"
                      : "#f5f5f5",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "13px",
                    color:
                      selectedDayWiseAverageType === "dockout_gateout"
                        ? "#ffffff"
                        : "#172b4d",
                  }}
                >
                  Dock Out
                </div>
                <div>
                  <img
                    src={
                      selectedDayWiseAverageType === "dockout_gateout"
                        ? DashWhitearrow
                        : Dasharrow
                    }
                    alt="arrow"
                  />
                </div>
                <div
                  style={{
                    fontWeight: "500",
                    fontSize: "13px",
                    color:
                      selectedDayWiseAverageType === "dockout_gateout"
                        ? "#ffffff"
                        : "#172b4d",
                  }}
                >
                  Gate Out
                </div>
              </div>
            </div>

            <div style={{ width: "100%", overflowX: "auto" }}>
              <BarChart
                data={dayWiseAverageChartData ?? []}
                barSize={12}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                width={700}
                height={220}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis
                  dataKey="day"
                  tickFormatter={(value) =>
                    value.length > 10 ? value.substring(0, 10) + "…" : value
                  }
                />
                <Tooltip cursor={{ fill: "transparent" }} />
                <Bar dataKey="avg" fill="#f66" radius={[10, 10, 0, 0]} />
              </BarChart>
            </div>
          </div>
        </Col>
      </Row>

      <div
        ref={vehicleWiseDockOverviewRef}
        style={{
          borderRadius: "16px",
          padding: "16px",
          backgroundColor: "#ffffff",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <Row>
          <Col sm={12}>
            <Row style={{ marginBottom: "16px" }}>
              <Col sm={12} md={6} lg={8} className="mb-3">
                <div className="style-justify-start">
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "16px",
                      color: "#172b4d",
                    }}
                  >
                    Vehicles came in and out count
                  </div>
                  <ExcelPDFDashboardButtons
                    selectedVehicleMonth={
                      selectedVehicleMonth !== null
                        ? `${selectedVehicleMonth.getFullYear()}-${String(
                            selectedVehicleMonth.getMonth() + 1
                          ).padStart(2, "0")}`
                        : ""
                    }
                    pdfRef={vehicleWiseDockOverviewRef}
                    downloadPdfRef={downloadLongPDF}
                    responseMsg={onFileResponse}
                    activeTab={"come_in_out"}
                    isExcel={true}
                    isPdf={true}
                  />
                </div>
              </Col>

              <Col
                sm={12}
                md={6}
                lg={4}
                className="mb-3"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "0px" }}
                >
                  <div className="style-justify-end">
                    <div className="vehicle-in-out-search-box me-2 flex items-center border rounded-md w-full md:w-auto">
                      <select
                        value={searchVehicleInOut}
                        onChange={(e) => {
                          setSearchVehicleInOut(e.target.value);
                        }}
                        style={{
                          flex: 1,
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#D35258",
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <option value="department">Department</option>
                        <option value="vehicletype">Vehicle Type</option>
                        <option value="vendor">Vendor</option>
                        <option value="transporter">Transporter</option>
                        <option value="customer">Customer</option>
                      </select>
                      <div className="vehicle-in-out-search-text">
                        <span className="ms-1 icon mr-2">
                          <img
                            src={search}
                            alt="search"
                            className="search-icon w-4 h-4"
                          />
                        </span>
                        <input
                          ref={searchInputRef}
                          type="text"
                          placeholder="Search"
                          className="outline-none w-full"
                          style={{ outline: "none", border: "none" }}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                  </div>
                  <div>
                    <select
                      value={vehicleTransType}
                      onChange={(e) => {
                        setVehicleTransType(e.target.value);
                      }}
                      style={{
                        height: "36px",
                        border: "1px solid #ebebeb",
                        padding: "0px 16px",
                        backgroundColor: "#ffffff",
                        borderRadius: "12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        color: "#d35258",
                      }}
                    >
                      <option value="in">Vehicle come in</option>
                      <option value="out">Vehicle come out</option>
                    </select>
                  </div>
                  <div
                    onClick={() => setShowVehicleMonthPicker(true)}
                    style={{
                      position: "relative",
                      width: "146px",
                      height: "36px",
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#842234",
                      }}
                    >
                      {formatDateCommon(
                        selectedVehicleMonth != null
                          ? selectedVehicleMonth
                          : undefined,
                        "MMM, YYYY"
                      )}{" "}
                      &nbsp; <img src={downArrow} />
                    </div>
                    {showVehicleMonthPicker && (
                      <div
                        ref={alertVehicleDateRef}
                        style={{
                          position: "absolute",
                          top: "40px",
                          right: "0",
                          zIndex: 100,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Calendar
                          onChange={handleVehicleMonthPickerChange}
                          value={selectedVehicleMonth}
                          view="year"
                          onClickMonth={(date) =>
                            handleVehicleMonthPickerChange(date)
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12} style={{ overflow: "scroll" }}>
                <div style={{ width: "fit-content" }}>
                  <div className="style-justify-start">
                    <div className="vehicle-root-box">
                      <select
                        value={selectedSideBar}
                        onChange={(e) => {
                          setSelectedSideBar(e.target.value);
                        }}
                        style={{
                          flex: 1,
                          width: "80px",
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#D35258",
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <option value="department">Department</option>
                        <option value="vehicletype">Vehicle Type</option>
                        <option value="vendor">Vendor</option>
                        <option value="transporter">Transporter</option>
                        <option value="customer">Customer</option>
                      </select>{" "}
                      /
                      <select
                        value={selectedTopBar}
                        onChange={(e) => {
                          setSelectedTopBar(e.target.value);
                        }}
                        style={{
                          flex: 1,
                          width: "80px",
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#D35258",
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <option value="department">Department</option>
                        <option value="vehicletype">Vehicle Type</option>
                        <option value="vendor">Vendor</option>
                        <option value="transporter">Transporter</option>
                        <option value="customer">Customer</option>
                      </select>
                    </div>
                    {vehicleInOutCount.length > 0 &&
                      vehicleInOutCount[0]?.map((title, index) => {
                        if (index !== 0) {
                          return <div className="heading-top-bar">{title}</div>;
                        } else {
                          return <div></div>;
                        }
                      })}
                  </div>
                  {/* {vehicleInOutCount.filter((_, index) => index !== 0).map((childArray, index) => (
                <div className="style-justify-start">
                    {childArray[index]?.map((childValue, index2) => 
                    {                      
                return (<div className={`${index2===0?'vehicle-root-box':'heading-top-bar'}`}>{childValue}</div>)
                    }
                    )}
                      </div> 
))} */}
                  {vehicleInOutCount.slice(1).map((row, rowIndex) => (
                    <div key={rowIndex} className="style-justify-start">
                      {row.map((cell, colIndex) => (
                        <div
                          key={"r" + rowIndex + colIndex}
                          className={`${
                            colIndex === 0
                              ? "vehicle-root-box"
                              : "heading-top-bar"
                          }`}
                        >
                          {cell}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>

      <div
        ref={deptWiseDockOverviewRef}
        style={{
          borderRadius: "16px",
          padding: "16px",
          backgroundColor: "#ffffff",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <Row>
          <Col sm={12}>
            <Row style={{ marginBottom: "16px" }}>
              <Col sm={12} md={6} lg={8} className="mb-3">
                <div className="style-justify-start">
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "16px",
                      color: "#172b4d",
                    }}
                  >
                    Department wise dock overview
                  </div>
                  <ExcelPDFDashboardButtons
                    selectedDeptMonth={
                      selectedDeptMonth != null
                        ? `${selectedDeptMonth.getFullYear()}-${String(
                            selectedDeptMonth.getMonth() + 1
                          ).padStart(2, "0")}`
                        : ""
                    }
                    pdfRef={deptWiseDockOverviewRef}
                    downloadPdfRef={downloadLongPDF}
                    responseMsg={onFileResponse}
                    activeTab={"department_log"}
                    isExcel={true}
                    isPdf={true}
                  />
                </div>
              </Col>

              <Col
                sm={12}
                md={6}
                lg={4}
                className="mb-3"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "0px" }}
                >
                  <div>
                    <select
                      value={selectedLocationId}
                      onChange={handleLocationChange}
                      style={{
                        height: "36px",
                        border: "1px solid #ebebeb",
                        padding: "0px 16px",
                        backgroundColor: "#ffffff",
                        borderRadius: "12px",
                        fontWeight: "600",
                        fontSize: "13px",
                        color: "#d35258",
                      }}
                    >
                      <option value="">Select Location</option>
                      {locations.map((loc) => (
                        <option key={loc.value} value={loc.value}>
                          {loc.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    onClick={() => setShowDeptMonthPicker(true)}
                    style={{
                      position: "relative",
                      width: "146px",
                      height: "36px",
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#842234",
                      }}
                    >
                      {formatDateCommon(
                        selectedDeptMonth != null
                          ? selectedDeptMonth
                          : undefined,
                        "MMM, YYYY"
                      )}{" "}
                      &nbsp; <img src={downArrow} />
                    </div>
                    {showDeptMonthPicker && (
                      <div
                        ref={alertDeptDateRef}
                        style={{
                          position: "absolute",
                          top: "40px",
                          right: "0",
                          zIndex: 100,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Calendar
                          onChange={handleDeptMonthPickerChange}
                          value={selectedDeptMonth}
                          view="year"
                          onClickMonth={(date) =>
                            handleDeptMonthPickerChange(date)
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>

            {departmentWiseData.map((dept, index) => (
              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#f8f8f8",
                  marginBottom: "16px",
                }}
              >
                <Row>
                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "16px",
                          color: "#d35258",
                        }}
                      >
                        {dept.name ?? ""}
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "16px",
                          color: "#172b4d",
                        }}
                      >
                        {dept.docks ?? "0"}{" "}
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: "16px",
                            color: "#172b4d",
                          }}
                        >
                          docks
                        </span>
                      </div>
                    </div>
                  </Col>

                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#66737e",
                        }}
                      >
                        Utilization % by duration
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "20px",
                          color: "#2c8c53",
                        }}
                      >
                        {dept.duration_util ?? "0"}%
                      </div>
                    </div>
                  </Col>

                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#66737e",
                        }}
                      >
                        Utilization % by vehicles
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "20px",
                          color: "#2c8c53",
                        }}
                      >
                        {dept.vehicle_util ?? "0"}%
                      </div>
                    </div>
                  </Col>

                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        title="Avg. duration for Dock in to Dock out"
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#66737e",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: "100%",
                        }}
                      >
                        Avg. duration for Dock in to Dock out
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "20px",
                          color: "#d35258",
                        }}
                      >
                        {dept.avgduration ?? "0"}%
                      </div>
                    </div>
                  </Col>

                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: "13px",
                          color: "#66737e",
                        }}
                      >
                        Vehicles count
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "20px",
                          color: "#d35258",
                        }}
                      >
                        {dept.vehicle ?? "0"}
                      </div>
                    </div>
                  </Col>
                  <div
                    onClick={() => {
                      setExpandIndex(expandIndex === index ? -1 : index);
                      if (expandIndex === -1) {
                        fetchDepartmentWiseDockData(dept.dept_id ?? 0);
                      }
                    }}
                    className="style-justify-center cursor-pointer"
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "100px",
                      background: expandIndex === index ? "#D35258" : "#FFFFFF",
                    }}
                  >
                    <img
                      alt="arrow"
                      src={expandIndex === index ? arrowUp : arrowDown}
                    />
                  </div>
                </Row>
                {expandIndex === index && (
                  <div
                    className="table-container table-responsive"
                    style={{ borderRadius: "12px" }}
                  >
                    <table
                      className="dock-percentage-table"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr
                          style={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#172B4D",
                          }}
                        >
                          {/*  <th style={{ height: "44px", padding: "8px 8px" }}>  
                                <input type="checkbox" />
                              </th> */}
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Dock name
                          </th>
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Utilization % by duration
                          </th>
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Utilization % by vehicles
                          </th>
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Avg. duration for Dock in to Dock out
                          </th>
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Vehicles count
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {departmentWiseDockData?.map((dockItem, index2) => (
                          <tr
                            key={"dock_table_" + index2}
                            style={{
                              backgroundColor: "#ffffff",
                              cursor: "pointer",
                              transition: "border-color 0.3s",
                            }}
                          >
                            {/* <td style={{ height: "44px", padding: "8px 8px" }}> 
                                <input type="checkbox" onClick={(e) => e.stopPropagation()} />
                                </td> */}
                            <td
                              className="overflow-hidden"
                              style={{
                                height: "44px",
                                width: "150px",
                                maxWidth: "200px",
                                padding: "8px 8px",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#172B4D",
                              }}
                            >
                              {dockItem.name ?? ""}
                            </td>
                            <td
                              className="overflow-hidden"
                              style={{
                                height: "44px",
                                width: "200px",
                                maxWidth: "250px",
                                padding: "8px 8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#2C8C53",
                              }}
                            >
                              {dockItem.duration_util ?? "0"}%
                            </td>
                            <td
                              style={{
                                height: "44px",
                                width: "150px",
                                padding: "8px 8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#2C8C53",
                              }}
                            >
                              {dockItem.vehicle_util ?? "0"}%
                            </td>
                            <td
                              className="overflow-hidden"
                              style={{
                                height: "44px",
                                width: "200px",
                                padding: "8px 8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#D35258",
                              }}
                            >
                              {dockItem.avgduration ?? ""}
                            </td>
                            <td
                              className="overflow-hidden"
                              style={{
                                height: "44px",
                                width: "150px",
                                padding: "8px 8px",
                                fontSize: "16px",
                                fontWeight: "600",
                                color: "#D35258",
                              }}
                            >
                              {dockItem.vehicle ?? ""}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </Col>
        </Row>
      </div>

      {/* Live moniter */}
      <div ref={liveMonitorRef}>
        <div className="style-justify-start">
          <div className="live_head">Live moniter</div>
          <ExcelPDFDashboardButtons
            pdfRef={liveMonitorRef}
            downloadPdfRef={downloadLongPDF}
            responseMsg={onFileResponse}
            activeTab={"live_moniter"}
            isExcel={true}
            isPdf={true}
          />
        </div>

        <Row className="live_contain row d-flex">
          {/* Loading Section */}
          <Col sm={12} md={6} lg={4} className="mt-3">
            <div className="live_boxses col">
              <div className="d-flex gap-1">
                <div
                  style={{
                    height: "12px",
                    width: "12px",
                    borderRadius: "50px",
                    backgroundColor: "#5FD991",
                    marginTop: "3px",
                  }}
                ></div>
                <div className="live_text">Ontime</div>
              </div>
              <div
                style={{
                  height: "425px",
                  overflow: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {liveMonitorList
                  ?.filter((item) => item.current_status === "ontime")
                  .map((detail, index) => (
                    <div
                      key={"ontime" + index}
                      className="live_box mt-3"
                      style={{
                        position: "relative",
                        backgroundColor: "#DBFFEA",
                      }}
                    >
                      <div>
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ height: "28px" }}
                        >
                          <div className="style-justify-start">
                            <div
                              style={{
                                fontSize: "15px",
                                fontWeight: "700",
                                color: "#172B4D",
                              }}
                            >
                              {detail.vehicle_number}
                            </div>
                            <div className="dot-box mx-3"></div>
                            {detail.dock_type === "load_in" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#2C8C53",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Loading
                              </div>
                            )}
                            {detail.dock_type === "load_out" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#6929E2",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Unloading
                              </div>
                            )}
                          </div>
                          <div className="box_btn">Ontime</div>
                        </div>
                        <div className="d-flex align-items-center">
                          <label className="box_label1">Est. Time : </label>
                          <label className="box_label2 ps-2">
                            {detail.estimated_time}
                          </label>
                        </div>
                        <div className="d-flex mt-2 gap-2">
                          <div className="d-flex flex-column">
                            <label className="box_label1">Dock in Time</label>
                            <label className="box_label2">
                              {detail.dock_in_time}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "3px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label className="box_label1">Dock Number</label>
                            <label className="box_label2">
                              {detail.display_name}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "2px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label className="box_label1">Timer</label>
                            <label className="box_label2">
                              <Timer
                                key={"ontime_timer" + index}
                                initialSeconds={parseDuration(detail.duration)}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="live_box_border"
                        style={{
                          position: "absolute",
                          left: "12px",
                          bottom: "0",
                        }}
                      ></div>
                    </div>
                  ))}
              </div>
            </div>
          </Col>

          {/* Delay Section */}
          <Col sm={12} md={6} lg={4} className="mt-3">
            <div className="live_boxses col">
              <div className="d-flex gap-1">
                <div
                  style={{
                    height: "12px",
                    width: "12px",
                    borderRadius: "50px",
                    backgroundColor: "#FFC267",
                    marginTop: "3px",
                  }}
                ></div>
                <div className="live_text">Delay</div>
              </div>
              <div
                style={{
                  height: "425px",
                  overflow: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {liveMonitorList
                  ?.filter((item) => item.current_status === "delay")
                  .map((detail, index) => (
                    <div
                      key={"delay" + index}
                      className="live_box mt-3"
                      style={{
                        position: "relative",
                        backgroundColor: "#FFF1DD",
                      }}
                    >
                      <div>
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ height: "28px" }}
                        >
                          <div className="style-justify-start">
                            <div
                              style={{
                                fontSize: "15px",
                                fontWeight: "700",
                                color: "#172B4D",
                              }}
                            >
                              {detail.vehicle_number}
                            </div>
                            <div className="dot-box mx-3"></div>
                            {detail.dock_type === "load_in" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#2C8C53",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Loading
                              </div>
                            )}
                            {detail.dock_type === "load_out" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#6929E2",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Unloading
                              </div>
                            )}
                          </div>
                          <div className="box_btn" style={{ color: "#FFC267" }}>
                            Delay
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <label className="box_label1">Est. Time : </label>
                          <label className="box_label2 ps-2">
                            {detail.estimated_time}
                          </label>
                        </div>
                        <div className="d-flex mt-2 gap-2">
                          <div className="d-flex flex-column">
                            <label className="box_label1">Dock in Time</label>
                            <label className="box_label2">
                              {detail.dock_in_time}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "3px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label className="box_label1">Dock number</label>
                            <label className="box_label2">
                              {detail.display_name}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "2px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label className="box_label1">Timer</label>
                            <label
                              className="box_label2"
                              style={{ color: "#FFC267" }}
                            >
                              <Timer
                                key={"delay_timer" + index}
                                initialSeconds={parseDuration(detail.duration)}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="live_box_border"
                        style={{
                          position: "absolute",
                          left: "12px",
                          bottom: "0",
                          backgroundColor: "#FFC267",
                        }}
                      ></div>
                    </div>
                  ))}
              </div>
            </div>
          </Col>

          {/* Over-Delay Section */}
          <Col sm={12} md={6} lg={4} className="mt-3">
            <div className="live_boxses col">
              <div className="d-flex gap-1">
                <div
                  style={{
                    height: "12px",
                    width: "12px",
                    borderRadius: "50px",
                    backgroundColor: "#FE8B90",
                    marginTop: "3px",
                  }}
                ></div>
                <div className="live_text">Over-Delay</div>
              </div>
              <div
                style={{
                  height: "425px",
                  overflow: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {liveMonitorList
                  ?.filter((item) => item.current_status === "overdelay")
                  .map((detail, index) => (
                    <div
                      key={"overdelay" + index}
                      className="live_box mt-3"
                      style={{
                        position: "relative",
                        backgroundColor: "#FFEAEB",
                      }}
                    >
                      <div>
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ height: "28px" }}
                        >
                          <div className="style-justify-start">
                            <div
                              style={{
                                fontSize: "15px",
                                fontWeight: "700",
                                color: "#172B4D",
                              }}
                            >
                              {detail.vehicle_number}
                            </div>
                            <div className="dot-box mx-3"></div>
                            {detail.dock_type === "load_in" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#2C8C53",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Loading
                              </div>
                            )}
                            {detail.dock_type === "load_out" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#6929E2",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Unloading
                              </div>
                            )}
                          </div>
                          <div className="box_btn" style={{ color: "#FE8B90" }}>
                            Over Delay
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <label className="box_label1">Est. Time : </label>
                          <label className="box_label2 ps-2">
                            {detail.estimated_time}
                          </label>
                        </div>
                        <div className="d-flex mt-2 gap-2">
                          <div className="d-flex flex-column">
                            <label className="box_label1">Dock in Time</label>
                            <label className="box_label2">
                              {detail.dock_in_time}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "3px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label className="box_label1">Dock number</label>
                            <label className="box_label2">
                              {detail.display_name}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "2px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label className="box_label1">Timer</label>
                            <label
                              className="box_label2"
                              style={{ color: "#FE8B90" }}
                            >
                              <Timer
                                key={"overdelay_timer" + index}
                                initialSeconds={parseDuration(detail.duration)}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="live_box_border"
                        style={{
                          position: "absolute",
                          left: "12px",
                          bottom: "0",
                          backgroundColor: "#FE8B90",
                        }}
                      ></div>
                    </div>
                  ))}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div
        style={{
          textAlign: "center",
          marginTop: "80px",
          fontWeight: "400",
          fontSize: "12px",
          color: "#172B4D",
        }}
      >
        Powered by{" "}
        <span>
          <img src={mawalog} />
        </span>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Default;

const Timer = ({ displayName, initialSeconds }) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    /* if (secondsLeft <= 0) return; */

    const timerId = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev + 1 : 0));
    }, 1000);

    return () => clearInterval(timerId);
  }, [secondsLeft]);

  return (
    <div /* style={{ marginBottom: "10px" }} */>
      <span>{formatDuration(secondsLeft)}</span>
    </div>
  );
};

const formatDuration = (totalSeconds) => {
  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

const parseDuration = (timeStr) => {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};
